function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M254.49,57.48H217V47a8.5,8.5,0,0,0-17,0V57.48H100V47a8.5,8.5,0,0,0-17,0V57.48H45.51A16.53,16.53,0,0,0,29,74V245a16.54,16.54,0,0,0,16.51,16.52h209A16.54,16.54,0,0,0,271,245V74A16.53,16.53,0,0,0,254.49,57.48ZM83,74.48V83a8.5,8.5,0,1,0,17,0V74.48H200V83a8.5,8.5,0,1,0,17,0V74.48h37v36H46v-36Zm-37,170v-117H254v117Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M171.9,162.81a29.64,29.64,0,0,0-10.34-6.48A37.54,37.54,0,0,0,148.07,154H127.24v63h21.09a38.37,38.37,0,0,0,13.59-2.29,27.37,27.37,0,0,0,16.61-16.37,35.13,35.13,0,0,0,2.23-12.73,34.39,34.39,0,0,0-2.32-12.79A28.21,28.21,0,0,0,171.9,162.81Zm-5.54,30.8a19,19,0,0,1-4.07,6.43,18.51,18.51,0,0,1-6.43,4.27,21.72,21.72,0,0,1-8.31,1.56h-8v-40.7h8.79a19.5,19.5,0,0,1,10,2.61,18.17,18.17,0,0,1,6.95,7.3,22.05,22.05,0,0,1,2.49,10.52A21.79,21.79,0,0,1,166.36,193.61Z"
});

var SvgCalendarDay = function SvgCalendarDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_day.3aa3294c.svg";
export { ForwardRef as ReactComponent };